module.exports = __webpack_public_path__ + "img/xu1-3.8da69d07.png";